import React from "react";
import View from "components/View";
import * as styles from "styles";

const Column = props => <View {...styles.column} {...props} />;

export default Column;
